import React from 'react';
import { EyeOff, MapPin } from 'lucide-react';

export function MapMockup() {
  const pins = [
    { x: 25, y: 30, type: 'city', label: 'Valdris' },
    { x: 60, y: 20, type: 'dungeon', label: 'Crypte' },
    { x: 45, y: 55, type: 'quest', label: 'Tour' },
    { x: 75, y: 65, type: 'danger', label: 'Dragon' },
  ];
  const pinColors = { city: '#3b82f6', dungeon: '#a855f7', quest: '#22c55e', danger: '#ef4444' };

  return (
    <div className="landing-mockup-card relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/40 via-stone-800/60 to-amber-900/30 rounded-xl" />
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-black/60 backdrop-blur-sm rounded-bl-3xl" style={{ borderBottomLeftRadius: '40%' }}>
        <div className="absolute inset-0 flex items-center justify-center">
          <EyeOff className="h-4 w-4 text-white/30" />
        </div>
      </div>
      <svg className="absolute inset-0 w-full h-full opacity-10">
        {Array.from({ length: 8 }).map((_, i) => (
          <React.Fragment key={i}>
            <line x1={`${(i + 1) * 12.5}%`} y1="0" x2={`${(i + 1) * 12.5}%`} y2="100%" stroke="white" strokeWidth="0.5" />
            <line x1="0" y1={`${(i + 1) * 12.5}%`} x2="100%" y2={`${(i + 1) * 12.5}%`} stroke="white" strokeWidth="0.5" />
          </React.Fragment>
        ))}
      </svg>
      {pins.map((pin, i) => (
        <div key={i} className="absolute landing-pin-bounce" style={{ left: `${pin.x}%`, top: `${pin.y}%`, animationDelay: `${i * 200}ms` }}>
          <div className="relative">
            <MapPin className="h-5 w-5 -translate-x-1/2 -translate-y-full drop-shadow-lg" style={{ color: pinColors[pin.type] }} />
            <span className="absolute -bottom-3 left-1/2 -translate-x-1/2 text-[8px] text-white/80 whitespace-nowrap font-medium">{pin.label}</span>
          </div>
        </div>
      ))}
      <div className="absolute bottom-2 left-2 text-[9px] bg-black/50 text-white/70 px-2 py-0.5 rounded backdrop-blur-sm">
        Terres du Nord — Niv. 2
      </div>
    </div>
  );
}
